import React from 'react';
import classes from './styles/ButtonBarWrapper.scss';

const ButtonBarWrapper = ({ children }) => (
    <div className={classes.ButtonBarWrapper}>{children}</div>
);

export default ButtonBarWrapper;
